
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getSendInvitationLinkDtoFormGroup() {
return new FormGroup({
    contactId: new FormControl<number | undefined>(undefined, [Validators.required, Validators.min(1)]),
    eventId: new FormControl<number | undefined>(undefined, [Validators.required, Validators.min(1)]),
})
;
}
      